<template>
  <div class="OAProp">
    <el-popover v-if="scope.row.invalidState==1" placement="top-start" width="200" trigger="hover"
      :content="scope.row.invalidReason">
      <el-button slot="reference" type="danger">已作废</el-button>
    </el-popover>
    <div v-if="scope.row.invalidState==0">正常</div>
  </div>
</template>

<script>
  export default {
    name: "OAProp",
    props: {
      scope: {
        default: null
      }
    },
    data() {
      return {};
    },
    mounted() {},
    methods: {}
  };

</script>



// WEBPACK FOOTER //
// src/components/OAProp/OAProp.vue